<script setup lang="ts">
import { IconVueFeather } from '@c4-links/vue3-links-components';

defineProps({
  icon: { type: String, required: true },
  title: { type: String, required: true },
  subtitle: { type: String, default: '' }
});
</script>

<template>
  <div
    class="flex flex-col justify-center items-center gap-2 border-solid border rounded-2xl p-10 border-default-neutral-217"
    data-test-id="error-card-container"
  >
    <div class="flex justify-center items-center size-[7.5rem] bg-gray-100 rounded-full">
      <IconVueFeather :type="icon" class="opacity-50" :size="66" />
    </div>
    <h1 class="text-2xl font-bold text-center mt-6 max-w-2xl" data-test-id="error-card-title">
      {{ title }}
    </h1>
    <p class="text-sm font-normal text-center max-w-2xl" data-test-id="error-card-subtitle">
      {{ subtitle }}
    </p>
    <slot />
  </div>
</template>
